import GamePage from "@/pages/GamePage";

function App() {
  return (
    <div
      style={{
        width: "100vw",
        height: "100dvh",
        margin: 0,
        padding: 0,
        overflow: "hidden",
        backgroundColor: "#000",
      }}
    >
      <GamePage />
    </div>
  );
}

export default App;
